
import { Component     } from '@angular/core';
import { ViewChild     } from '@angular/core';
import { ElementRef    } from '@angular/core';
import { HostListener  } from '@angular/core';
import { DomSanitizer  } from '@angular/platform-browser';

import { ConsoleService    } from '@service/console.service';
import { PlatformService   } from '@service/platform.service';
import { FilesystemService } from '@service/filesystem.service';

@Component({
    selector: 'section-about',
    styleUrls: [ 'section-about.template.scss' ],
    templateUrl: 'section-about.template.html'
})
export class SectionAboutComponent {

    public ready: boolean = false;

    public smallOptions: any = {
        items: 1,

        nav: true,
        dots: false,
        loop: true,
        navText: ['<', '>'],

        autoplay: false,
        smartSpeed: 500,
        autoplayTimeout: 10000,
        autoplayHoverPause: true,
        autoplayMouseleaveTimeout: 10000,

        responsive: {
            0: { items: 1 }
        }
    };

    public largeOptions: any = {
        items: 1,

        nav: false,
        dots: false,
        loop: true,
        smartSpeed: 500,

        responsive: {
            0: { items: 1 }
        }
    };

    public tick:number = 0;
    public percent:number = 0;

    public offsetscale: number = 0;
    public offsetscroll: number = 0;
    public slidePosition: number = 1;
    public slidePositionMobile: number = 1;

    public content: any = [];
    public visible: boolean = false;
    public animate: boolean = false;

    public playing: boolean = false;
    public animateVideo: boolean = false;

    public videoLink: any = null;

    @ViewChild('small')
    public small!: any;

    @ViewChild('large')
    public large!: any;

    @ViewChild('checkpoint')
    public checkpoint!: ElementRef;

    @ViewChild('checkpointVideo')
    public checkpointVideo!: ElementRef;

    constructor (private sanitizer: DomSanitizer,
                 private console: ConsoleService,
                 private platform: PlatformService,
                 private filesystem: FilesystemService) {

    }

    public controlIt: any = 0;

    ngOnInit () {
        this.console.info('Starting SectionAbout');

        let main: any = this.filesystem.readSession('main');
        if (main) {
            this.content = main;
        }

        this.control();

        setTimeout(() => { this.ready = true; }, 3000);
    }

    ngOnDestroy () {
        this.console.info('Destroying SectionAbout');
    }

    public control () {
        let state = this.controlIt ? true : false;
        
        clearInterval(this.controlIt);

        this.controlIt = false;

        if (! state)
            this.controlIt = setInterval(() => {
                this.tick++;

                this.percent = this.tick / 15 * 100;

                if (this.percent == 100) {
                    this.small?.navigationService.next(500);
                    this.tick = 0;
                    this.percent = 0;
                }
            }, 500);
    }

    get mobile () {
        return this.ready && window.innerWidth <= 992 ? true : false;
    }

    get language () {
        return this.filesystem.readSession('language');
    }

    public encapsulate (text: string) {
        return this.platform.encapsulate(text);
    }

    public video () {
        this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.content[this.language].about.video.link + '?autoplay=1&rel=1'
        );
    }

    public translated ($event: any) {
        this.slidePosition = $event.startPosition + 1;
        this.small?.navigationService.to($event.startPosition);

        setTimeout(() => {
            this.tick = 0;
            this.percent = 0;
            this.large?.navigationService.to($event.startPosition);
        }, 100);
    }

    public translatedMobile ($event: any) {
        this.slidePositionMobile = $event.startPosition + 1;
    }

    @HostListener('window:scroll', [ '$event' ])
    @HostListener('window:resize', [ '$event' ])
    public animateBySrcoll ($event: any) {
        this.visible = window.scrollY > 0;
        
        this.offsetscale = window.scrollY / this.platform.offset(this.checkpointVideo?.nativeElement);
        this.offsetscroll = window.scrollY / this.platform.offset(this.checkpoint?.nativeElement);

        this.animate = this.platform.isInView(
            this.checkpoint.nativeElement, window.innerHeight / 3
        );
    }

}
